import React from 'react';
import Icon, { IconProps } from './Icon';

const MerchIcon: React.FC<IconProps> = ({ size = 28, color = '#343B91', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 28 28" {...props}>
      <path
        d="M24.5 8.16663L23.9167 14L21 12.25V23.3333H7V17.7916M21 4.66663H17.5C17.5 5.12626 17.4095 5.58137 17.2335 6.00602C17.0577 6.43066 16.7999 6.81649 16.4748 7.1415C16.1498 7.46651 15.764 7.72431 15.3394 7.90021C14.9148 8.07609 14.4597 8.16663 14 8.16663C13.5403 8.16663 13.0852 8.07609 12.6605 7.90021C12.236 7.72431 11.8502 7.46651 11.5251 7.1415C11.2001 6.81649 10.9423 6.43066 10.7664 6.00602C10.5905 5.58137 10.5 5.12626 10.5 4.66663H7L3.5 8.16663L4.08333 14L7 12.25"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};

export default MerchIcon;

